import React, { Component } from 'react'
import UserImage from './../../../assets/images/user.jpg';
import upload from '../../../../src/assets/images/cloud-data-upload-icon.svg';
import FilterActiveIcon from './../../../icons/filteractiveicon';
import FilterIcon from './../../../icons/filtericon';
import service from '../../../../src/services'
import Loader from '../../loader';
import moment from 'moment-timezone'
import serachIcon from './../../../assets/images/search.svg'
import commonImage from "../../../commonImage";

import TextField from './../../../component/TextField'
import CopyToClipboard from "copy-to-clipboard";
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'

import ReactPaginate from "react-paginate";
import ShowPasswordIcon from '../../../icons/ShowPassIcon';
import ViewIcon from '../../../icons/viewIcon';
import { Link } from 'react-router-dom';
import ErrorPopUp from '../../errorPopUp';

let genreData;
let sub;
let statusFilterList = []
let programFilterList = []
let awardCategoryList = []


const mapStateToProps = state => ({
    filmEditId: state.filmEditId,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

class FilmListTable extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isExist: true,
            filmAccessData: '',
            filmAccessDate: '',
            userEmail: '',
            activetab: 0,
            searchField: '',
            exploreListFlim: [],
            showPass: false,
            filmList: [],
            programArray: [],
            awardCategoryArray: [],
            loaderFlag: false,
            Filmoffset: 0,
            perPage: 50,
            FilmCurrentPage: 0,
            screenmodal: false,
            ScreenerPopupData: '',
            ScreenerPopupFilmData: '',
            assendingVotes: true,
            assendingRating: true,
            addScreenerPopup: false,
            statusArray: [
                { assign: "Live", list: 1, value: false },
                { assign: "Disable", list: 2, value: false },
            ],
            fileUploading: false,
            errorPopup: false,
            successmodal: false,
            filmId: this.props.filmEditId,

        }
        this.apiserve = new service();

    }

    componentDidMount = () => {
        this.apiserve.sendevent("user|sff|getAllInitialForRedis", {});
        this.apiserve.sendevent("FestivalSetting|getFestivalSetting",{type:'FPG_GUIDE_PDF'});


        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "user|sff|getAllInitialForRedis":
                    var programData = response.data.film && response.data.film.category.map(function (el) {
                        let o = Object.assign({}, el);
                        o.value = false;
                        return o;
                    });
                    var awardCategoryData = response.data.film && response.data.film.awardCategory.map(function (el) {
                        let o = Object.assign({}, el);
                        o.value = false;
                        return o;
                    });
                    this.setState({
                        filmList: response.data.film,
                        programArray: programData,
                        awardCategoryArray: awardCategoryData
                    })

                    let FilmCurrentPage = localStorage.getItem('FilmCurrentPage')
                    if (FilmCurrentPage) {
                        this.setState(
                            {
                                Filmoffset: parseInt(localStorage.getItem("Filmoffset")),
                                perPage: parseInt(localStorage.getItem("perPage")),
                                FilmCurrentPage: parseInt(localStorage.getItem("FilmCurrentPage")),
                            },
                            () =>
                                this.getFilmList(this.state.Filmoffset, this.state.perPage)
                        );
                    } else {
                        this.setState({
                            Filmoffset: 0,
                            perPage: 50,
                            FilmCurrentPage: 0
                        },
                            () =>
                                this.getFilmList(this.state.Filmoffset, this.state.perPage))
                    }


                    break;
                case "film|getList":
                    let data = JSON.parse(JSON.stringify(response.data.docs))
                    data.map(item => {
                        if(item.shortProgramme && item.shortProgramme.dateTime ){
                            item.shortProgramme.dateTime = item.shortProgramme.dateTime.sort((a, b) => a.date > b.date ? 1 : -1)
                        } else {
                            item.dateTime = item.dateTime.sort((a, b) => a.date > b.date ? 1 : -1)
                        }
                    })
                    this.setState({
                        exploreListFlim: data,
                        pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                        loaderFlag: false,
                        disableFilter: false
                    })
                    break;
                case "fpg|screenerCredential|addPassword":
                    if (!response.error) {
                        this.setState({
                            screenmodal: false,
                            password: ''
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;

                case "user|checkStatus":
                    if (!response.error) {
                        this.setState({
                            isExist: response.data.isExist,
                            userEmail: response ?.data ?.user
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "admin|screening|getMasterLink":
                    if (!response.error) {
                        this.setState({
                            linkCopy: response ?.data ?.link
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "FestivalSetting|setFestivalSetting":
                    if (!response.error) {
                        this.apiserve.sendevent("FestivalSetting|getFestivalSetting",{type:'FPG_GUIDE_PDF'});
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                    case "FestivalSetting|getFestivalSetting":
                        if (!response.error) {
                        this.setState({
                            fileUploading: false,
                            uploadDate: response?.data?.updatedAt,
                            uploadFname: response?.data?.updatedBy?.fname,
                            uploadLname: response?.data?.updatedBy?.lname
                        }, () => {
                            this.setState({
                                uploadPDFModal: true
                            })
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                default:
                    break;
            }
        });
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        statusFilterList = [];
        programFilterList = [];
        awardCategoryList = [];
    };

    getFilmList = (skip, limit) => {
        this.setState({
            loaderFlag: true
        })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (statusFilterList && statusFilterList.length) {
            data.status = statusFilterList
        }
        if (programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        if (awardCategoryList && awardCategoryList.length) {
            data.awardCategory = awardCategoryList
        }

        data.page = skip
        data.limit = limit
        this.apiserve.sendevent("film|getList", data)

    }

    editData = (item) => {
        this.props.NewFrontierEditData()
        this.props.filmEditData(item)
        this.props.TalkEventEditData()
        this.props.OtherEventsEditData()
        this.props.LiveSceeringEditData()

        this.props.CurrentTab(0)
        // this.props.dispatch({type:   'CurrentTab', res: 0})
        this.props.history.push({
            pathname: `/film/${item}`,
            callFrom: 0
        });
    }

    categoryList = (id) => {
        var filmGenre = this.state.filmList && this.state.filmList.category
        var names = []
        filmGenre.forEach(f => {
            if (f._id === id) {
                names.push(f.name)
            }
        });

        return names.map(name => {
            return (<p>{name}</p>)
        })
    }

    generList = (id) => {
        var filmGenre = this.state.filmList && this.state.filmList.genre
        var names = []
        filmGenre.forEach(f => {
            if (f._id === id) {
                names.push(f.name)
            }
        });

        return names.map(name => {
            return (<p>{name}</p>)
        })
    }

    interestTrackList = (id) => {
        var filmGenre = this.state.filmList && this.state.filmList.interestTrack
        var names = []
        filmGenre.forEach(f => {
            if (f._id === id) {
                names.push(f.name)
            }
        });

        return names.map(name => {
            return (<p>{name}</p>)
        })
    }

    // accessibilityList = (id) => {
    //     var filmGenre = this.state.filmList && this.state.filmList.accessibility
    //     var names = []
    //     filmGenre.forEach(f => {
    //         if (f._id === id) {
    //             names.push(f.name)
    //         }
    //     });

    //     return names.map(name => {
    //         return (<p>{name}</p>)
    //     })
    // }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const Filmoffset = selectedPage + 1;
        // page scroll top
        var tbl = document.querySelector(".film_list_table");
        tbl.scrollTo(0, 0);

        this.setState(
            {
                FilmCurrentPage: selectedPage,
                Filmoffset: Filmoffset,
                loaderFlag: true
            },
            () => {
                localStorage.setItem('FilmCurrentPage', this.state.FilmCurrentPage)
                localStorage.setItem('Filmoffset', Filmoffset)
                localStorage.setItem('perPage', this.state.perPage)
                this.getFilmList(Filmoffset, this.state.perPage);
            }
        );
    };

    StatusFilter = (e, selectedInex, isClearStatusType = false, isClearProgramType) => {

        let index = selectedInex
        let event = e && e.target && e.target.checked
        let approvePassList = [...this.state.statusArray]
        approvePassList.forEach((key, i) => {
            if (i === index) {
                approvePassList[i].value = event
            }
            if (isClearStatusType) {
                approvePassList[i].value = false
                statusFilterList = []
            }

        })
        this.setState({
            ...this.state,
            statusArray: approvePassList,
            FilmCurrentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    statusFilterList = [...statusFilterList, this.state.statusArray[index].list];
                }

            } else {
                if (index !== null) {
                    let tempArray = statusFilterList.filter((d) => d !== this.state.statusArray[index].list);
                    statusFilterList = tempArray;
                }
            }
            this.getFilmFilter(this.state.Filmoffset, this.state.perPage, isClearStatusType.isClearProgramType);
        })
    }

    programFilter = (e, selectedInex, isClearStatusType, isClearProgramType = false) => {

        let index = selectedInex
        let event = e && e.target && e.target.checked
        let approvePassList = [...this.state.programArray]
        approvePassList.forEach((key, i) => {
            if (i === index) {
                approvePassList[i].value = event
            }
            if (isClearProgramType) {
                approvePassList[i].value = false
                programFilterList = []
            }

        })
        this.setState({
            ...this.state,
            programArray: approvePassList,
            FilmCurrentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    programFilterList = [...programFilterList, this.state.programArray[index]._id];
                }

            } else {
                if (index !== null) {
                    let tempArray = programFilterList.filter((d) => d !== this.state.programArray[index]._id);
                    programFilterList = tempArray;
                }
            }
            this.getFilmFilter(this.state.Filmoffset, this.state.perPage, isClearStatusType, isClearProgramType);
        })
    }

    awardCategoryFilter = (e, selectedInex, isClearStatusType, isClearProgramType, isClearAwardType) => {

        let index = selectedInex
        let event = e && e.target && e.target.checked
        let awardList = [...this.state.awardCategoryArray]
        awardList.forEach((key, i) => {
            if (i === index) {
                awardList[i].value = event
            }
            if (isClearAwardType) {
                awardList[i].value = false
                awardCategoryList = []
            }

        })
        this.setState({
            ...this.state,
            awardCategoryArray: awardList,
            FilmCurrentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    awardCategoryList = [...awardCategoryList, this.state.awardCategoryArray[index]._id];
                }

            } else {
                if (index !== null) {
                    let tempArray = awardCategoryList.filter((d) => d !== this.state.awardCategoryArray[index]._id);
                    awardCategoryList = tempArray;
                }
            }
            this.getFilmFilter(this.state.Filmoffset, this.state.perPage, isClearStatusType, isClearProgramType, isClearAwardType);
        })
    }

    getFilmFilter = (skip, limit, isClearStatusType, isClearProgramType, isClearAwardType) => {

        let data = {
            page: 1,
            limit: limit
        }

        if (!isClearStatusType && statusFilterList && statusFilterList.length) {
            data.status = statusFilterList
        }
        if (!isClearProgramType && programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        if (!isClearAwardType && awardCategoryList && awardCategoryList.length) {
            data.awardCategory = awardCategoryList
        }
        this.setState({
            disableFilter: true
        })
        this.apiserve.sendevent("film|getList", data);
    }



    //Search Data
    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            FilmCurrentPage: 0
        }, () => {
            var data = {
                page: 1,
                limit: 50,
            }
            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
            if (statusFilterList && statusFilterList.length) {
                data.status = statusFilterList
            }
            if (programFilterList && programFilterList.length) {
                data.category = programFilterList
            }
            if (awardCategoryList && awardCategoryList.length) {
                data.awardCategory = awardCategoryList
            }
            this.apiserve.sendevent("film|getList", data);
        });
    }

    votesSorting = (status) => {
        if (status) {
            var data = {
                "sortBy": "votes",
                "sortOrder": 1
            }
            this.setState({ assendingVotes: false })
        } else {
            var data = {
                "sortBy": "votes",
                "sortOrder": -1
            }
            this.setState({ assendingVotes: true })
        }

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        if (statusFilterList && statusFilterList.length) {
            data.status = statusFilterList
        }
        if (programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        if (awardCategoryList && awardCategoryList.length) {
            data.awardCategory = awardCategoryList
        }
        this.apiserve.sendevent("film|getList", data);
    }

    ratingSorting = (status) => {
        if (status) {
            var data = {
                "sortBy": "rating",
                "sortOrder": 1
            }
            this.setState({ assendingRating: false })
        } else {
            var data = {
                "sortBy": "rating",
                "sortOrder": -1
            }
            this.setState({ assendingRating: true })
        }
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        if (statusFilterList && statusFilterList.length) {
            data.status = statusFilterList
        }
        if (programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        if (awardCategoryList && awardCategoryList.length) {
            data.awardCategory = awardCategoryList
        }
        this.apiserve.sendevent("film|getList", data);
    }

    ScreenerPopup = (e, data, filmData) => {
        e.stopPropagation();
        this.setState({
            screenmodal: true,
            ScreenerPopupData: data,
            ScreenerPopupFilmData: filmData
        })
    }


    ClickAddScreenerPopup = (e, item, date) => {
        e.stopPropagation();
        this.setState({
            addScreenerPopup: true,
            filmAccessData: item,
            filmAccessDate: date
        })
    }
    CloseModal = () => {
        this.setState({
            addScreenerPopup: false,
            email: '',
            isExist: true,
            userEmail: '',
            linkCopy: ''
        })
    }

    scannerLogin = (e, date, item) => {
        e.stopPropagation();
        e.preventDefault();
        let data = {}
        data.film = date._id
        data.filmType = "Film"
        let scannerLogin = this.apiserve.encrypt(data)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_CMS + 'moderator/signin?data=' + scannerLogin);

        // this.props.history.push('/screening-signin')
    }

    onInputChange = (e) => {
        const { name, value } = e.target
        if(name === 'password'){
            let passwordErr = ''
        if(value.length > 0){
            if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
                passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
            } else {
                passwordErr = ''
            }
        } else {
            passwordErr = 'Password can not be blank'
        }
        this.setState({
            passwordErr : passwordErr,
            [name]:value
        })
        } else {
            this.setState({
                [name]: value
            })
        }
    }

    scannerSave = (date, data) => {
        const isValid = this.validate()
        if (isValid) {
            var data = {
                "filmId": data._id,
                "date": date._id,
                "filmType": "Film",
                "password": this.state.password
            }
            this.apiserve.sendevent("fpg|screenerCredential|addPassword", data);
        }
    }

    validate = () => {
        let passwordErr = '';
        if (!this.state.password) {
            passwordErr = 'Password can not be blank'
        }
        else {
            if (!this.state.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
                passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
            }
        }

        this.setState({
            passwordErr
        })
        if (passwordErr) {
            return false
        }
        return true
    }

    Showpassword = () => {
        this.setState({
            showPass: !this.state.showPass
        })
    }

    setEmailGo = (e) => {
        e.preventDefault();
        var data = {
            email: this.state.email
        }
        this.apiserve.sendevent("user|checkStatus", data);
    }

    setLink = (e) => {
        e.preventDefault();
        const { email, filmAccessData, filmAccessDate } = this.state
        var data = {
            "film": filmAccessData ?._id,
            "date": filmAccessDate ?._id,
            "filmType": "Film",
            "email": email.trim()
        }
        this.apiserve.sendevent("admin|screening|getMasterLink", data);
    }

    copyLink = (e, link) => {
        e.preventDefault();
        CopyToClipboard(link);
        this.apiserve.success('Link Copied!')
    }

    getLocationslist = (locations) => {

        let emptyData = []

        locations.map(location => {
            emptyData.push(location.name)
        });

        return emptyData.join(', ')
    }

    uploadPDF = (e) => {
        let file = e.target.files[0];
        if ((file.type === 'text/pdf') || file.name.includes('.pdf')) {
            this.setState({
                fileUploading: true
            })
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (event) => {
                setTimeout(() => {
                    this.imageUploadScreen(file,true,event.target.result);
                }, 0);
            };
            e.target.value = ''
        } else {
            this.setState({ errorMsg: 'please upload .PDF file only', errorPopup: true, fileUploading: false })
        }
    }

    imageUploadScreen = (file,IsFPGUpload=false, img) => {
        var fileSet = commonImage(file,IsFPGUpload, this.apiserve.formbucket,img)
        fileSet.then((value) => {
            var data = {
                url: encodeURI(process.env.REACT_APP_IMAGE_URL + value),
                type:('FPG_GUIDE_PDF'),
            }
            this.apiserve.sendevent("FestivalSetting|setFestivalSetting", data);   
            console.log("data---------",data);
        });

    };

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }
    
    CloseModal = () => {
        if ( this.state.successmodal === true ) {
            this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                this.getGeneralList(this.state.offset, this.state.perPage) :
                this.getEventList(this.state.offset, this.state.perPage);
        }
        this.setState({
            successmodal: false,
        })
    }
    render() {
        const { exploreListFlim, statusArray, programArray, awardCategoryArray, ScreenerPopupData, ScreenerPopupFilmTitle, ScreenerPopupFilmData, assendingVotes, assendingRating } = this.state
        return (
            <>
            <div className="film_list_table striped_table">
                <table className="tbl_layout_fix">
                    <thead>
                        <tr>
                            <th style={{ width: "325px" }}>
                                <div className="dashboard_header no_bg p_0">
                                    <div className="searchBlock back_date pl_15">
                                        <form onSubmit={e => { e.preventDefault(); }} className="m_0">
                                            <input
                                                className="bg_white"
                                                type="text"
                                                autoComplete={false}
                                                placeholder="Search"
                                                id="searchField"
                                                name="searchField"
                                                value={this.state.searchField}
                                                onChange={this.onSearchFilter} />
                                            <button type='button' style={{ pointerEvents: 'none' }}>
                                                <img src={serachIcon} />
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </th>
                            <th style={{ width: "165px" }}>
                                <span className="disp_flex d_flex_align_center">Program
                                    {programFilterList && programFilterList.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }
                                </span>

                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                <p className="link" onClick={() => this.programFilter(null, null, null, true)}>Clear All</p>
                                            </div>

                                            <div className="customCheckBox">
                                                {programArray.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item._id}
                                                            name={item._id}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => this.programFilter(e, i)}
                                                            disabled={this.state.disableFilter}
                                                        />
                                                        <label htmlFor={item._id}>{item.name}</label>
                                                    </div>
                                                ))
                                                }
                                                </div>
                                                </div>
                                        </form>
                                    </div>  
                                </th> 
                                <th style={{width:"180px"}}>Genre</th>
                            <th style={{width:"170px"}}>Interest Tracks</th>
                            <th style={{width:"190px"}}>Accessibility</th>
                            <th style={{width:"520px"}}>Date-Time (MT)-Location
                                    <span style={{width:"90px",marginLeft:"165px",display:"inline-block"}}>Screener</span>
                            </th>
                            {/* <th style={{width:"90px"}}>Screener</th> */}
                            <th style={{width:"150px"}}> 
                                <span className="disp_flex d_flex_align_center">Status 
                                {statusFilterList && statusFilterList.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }
                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                <p className="link" onClick={() => this.StatusFilter(null, null, true, null)}>Clear All</p>
                                            </div>

                                            <div className="customCheckBox">
                                                {statusArray.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={'status' + item.list}
                                                            name={'status' + item.list}
                                                            value={item.list ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => this.StatusFilter(e, i)}
                                                        />
                                                        <label htmlFor={'status' + item.list}>{item.assign}</label>
                                                    </div>
                                                ))
                                                }
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th style={{ width: "150px" }}>
                                <span className="disp_flex d_flex_align_center">Award Category
                                {awardCategoryList && awardCategoryList.length ?
                                        <FilterActiveIcon />
                                        :
                                        <FilterIcon />
                                    }
                                </span>
                                <div className="tabelData_popup">
                                    <form>
                                        <div className="customCheck">
                                            <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                <p className="link" onClick={() => this.awardCategoryFilter(null, null, false, false, true)}>Clear All</p>
                                            </div>

                                            <div className="customCheckBox">
                                                {awardCategoryArray.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            id={item._id}
                                                            name={item._id}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => this.awardCategoryFilter(e, i)}
                                                            disabled={this.state.disableFilter}

                                                        />
                                                        <label htmlFor={item._id}>{item.name}</label>
                                                    </div>
                                                ))
                                                }
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            {/* <th style={{ width: "130px" }} className='pointer'>
                                <span className={assendingVotes ? "d_flex disp_flex d_flex_align_center" : "d_flex disp_flex dropdown_filter d_flex_align_center active"}>Votes
                                    {assendingVotes ?
                                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => this.votesSorting(true)}>
                                            <path d="M12 8L7 3L2 8L0 7L7 0L14 7L12 8Z" fill="black" />
                                        </svg>
                                        :
                                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => this.votesSorting(false)}>
                                            <path d="M12 8L7 3L2 8L0 7L7 0L14 7L12 8Z" fill="black" />
                                        </svg>
                                    }
                                </span>
                            </th>
                            <th style={{ width: "130px" }} className='pointer'>
                                <span className={assendingRating ? "d_flex disp_flex d_flex_align_center" : "d_flex disp_flex dropdown_filter d_flex_align_center active"}>Rating
                                {assendingRating ?
                                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => this.ratingSorting(true)}>
                                            <path d="M12 8L7 3L2 8L0 7L7 0L14 7L12 8Z" fill="black" />
                                        </svg>
                                        :
                                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => this.ratingSorting(false)}>
                                            <path d="M12 8L7 3L2 8L0 7L7 0L14 7L12 8Z" fill="black" />
                                        </svg>
                                    }
                                </span>
                            </th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {exploreListFlim && exploreListFlim.length > 0 && exploreListFlim.map((item, i) => {
                            let shortProgramme = new Date(item.shortProgramme && item.shortProgramme.date)
                            return (
                                <tr onClick={() => this.editData(item._id)} className={`pointer ${item.status === 2 ? 'disable' : ''}`}>
                                    <td style={{ width: "325px" }}>
                                        <div className="disp_flex">
                                            <div className="film_banner">
                                                <img src={
                                                    item.images ?.inSite ? this.apiserve.imageUrl + item.images ?.inSite :
                                                        item.images ?.link ? item.images ?.link :
                                                            '/images/image-placeholder.png'
                                                } />
                                            </div>
                                            <div className="film_desc">
                                                <h3>{item.title}</h3>
                                                <div className="disp_flex d_flex_align_center">
                                                    <span>{item.runTime} min</span>
                                                </div>
                                            </div>
                                        </div>
                                </td>
                                <td style={{width:"165px"}}>
                                    <div>
                                        <p>{item && item.category && item.category.name}</p>
                                    </div>
                                </td>
                                <td style={{width:"77px"}}>
                                    <div>
                                        {item.genre && item.genre.map(e => {
                                            return this.generList(e)
                                        })}
                                    </div>
                                </td>
                                <td style={{width:"106px"}}>
                                    <div>
                                        {item.interestTrack && item.interestTrack.map(e => {
                                            return this.interestTrackList(e)
                                        })}
                                    </div>
                                </td>
                                <td style={{width:"127px"}}>
                                    <div>
                                        {item.accessibility && item.accessibility.map(e => {
                                            return <p>{e.name}</p>
                                        })} 
                                    </div>
                                </td>
                                <td >
                                    <div >
                                        {item.shortProgramme && item.shortProgramme.dateTime ? item.shortProgramme.dateTime.map(date => {
                                                    return(
                                                        // <p>{moment(date.date).format('MMM DD')} - {moment(date.date).format("h:mm A")}</p> 
                                                        <div className="d_flex d_flex_align_center mb_5">
                                                        <p className="aa" style={{width:"310px"}}>{moment(date.date).tz("US/Mountain").format('MMM DD - h:mm A')} { date.locationType === undefined || date.locationType === "2" ? '- Online' : date.locations.length > 0 ? ' - ' + this.getLocationslist(date.locations) : ''}</p>
    
                                                        {date.screeningType === "1" && date.locationType === "2" ?
                                                                <div className="d_flex d_flex_align_center" style={{width:"50px",marginLeft:"20px"}}>
                                                                    <span className="mr_10 pointer" onClick={(e) => this.ScreenerPopup(e,date,item)}>
                                                                        <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M9.33333 5.33333H3.33333V3.33333C3.33333 2.23067 4.23067 1.33333 5.33333 1.33333C6.436 1.33333 7.33333 2.23067 7.33333 3.33333H8.66667C8.66667 1.49533 7.17133 0 5.33333 0C3.49533 0 2 1.49533 2 3.33333V5.33333H1.33333C0.979711 5.33333 0.640573 5.47381 0.390524 5.72386C0.140476 5.97391 0 6.31305 0 6.66667V12C0 12.3536 0.140476 12.6928 0.390524 12.9428C0.640573 13.1929 0.979711 13.3333 1.33333 13.3333H9.33333C9.68695 13.3333 10.0261 13.1929 10.2761 12.9428C10.5262 12.6928 10.6667 12.3536 10.6667 12V6.66667C10.6667 6.31305 10.5262 5.97391 10.2761 5.72386C10.0261 5.47381 9.68695 5.33333 9.33333 5.33333ZM4.04067 8.99933C4.12261 8.68562 4.31596 8.41247 4.58459 8.23089C4.85321 8.04932 5.17876 7.97174 5.5004 8.01265C5.82205 8.05356 6.11781 8.21016 6.33243 8.4532C6.54705 8.69624 6.66586 9.0091 6.66667 9.33333C6.66628 9.56649 6.60446 9.79544 6.48742 9.9971C6.37038 10.1988 6.20226 10.366 6 10.482V12H4.66667V10.482C4.41441 10.3375 4.21656 10.1141 4.10348 9.8463C3.9904 9.57846 3.96833 9.28092 4.04067 8.99933Z" fill="black" />
                                                                        </svg>
                                                                    </span>
                                                                    <span className="mr_10 pointer" onClick={(e) => this.scannerLogin(e, date, item)}>
                                                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.19997 0.133303C0.91707 0.133303 0.645759 0.245683 0.44572 0.445722C0.245681 0.645761 0.133301 0.917072 0.133301 1.19997V10.8C0.133301 11.0829 0.245681 11.3542 0.44572 11.5542C0.645759 11.7543 0.91707 11.8666 1.19997 11.8666H10.8C11.0829 11.8666 11.3542 11.7543 11.5542 11.5542C11.7543 11.3542 11.8666 11.0829 11.8666 10.8V7.06664C11.8666 6.92519 11.8104 6.78953 11.7104 6.68951C11.6104 6.58949 11.4748 6.5333 11.3333 6.5333C11.1919 6.5333 11.0562 6.58949 10.9562 6.68951C10.8562 6.78953 10.8 6.92519 10.8 7.06664V10.8H1.19997V1.19997H4.9333C5.07475 1.19997 5.21041 1.14378 5.31042 1.04376C5.41044 0.94374 5.46663 0.808085 5.46663 0.666636C5.46663 0.525187 5.41044 0.389532 5.31042 0.289512C5.21041 0.189493 5.07475 0.133303 4.9333 0.133303H1.19997ZM11.7109 0.289036C11.8101 0.388464 11.866 0.523 11.8666 0.663436V3.86664C11.8666 4.00809 11.8104 4.14374 11.7104 4.24376C11.6104 4.34378 11.4748 4.39997 11.3333 4.39997C11.1919 4.39997 11.0562 4.34378 10.9562 4.24376C10.8562 4.14374 10.8 4.00809 10.8 3.86664V1.9541L5.3109 7.44424C5.26131 7.49382 5.20245 7.53316 5.13766 7.55999C5.07287 7.58683 5.00343 7.60064 4.9333 7.60064C4.86317 7.60064 4.79373 7.58683 4.72895 7.55999C4.66416 7.53316 4.60529 7.49382 4.5557 7.44424C4.50611 7.39465 4.46678 7.33578 4.43994 7.27099C4.41311 7.2062 4.39929 7.13676 4.39929 7.06664C4.39929 6.99651 4.41311 6.92707 4.43994 6.86228C4.46678 6.79749 4.50611 6.73862 4.5557 6.68904L10.0458 1.19997H8.1333C7.99185 1.19997 7.8562 1.14378 7.75618 1.04376C7.65616 0.94374 7.59997 0.808085 7.59997 0.666636C7.59997 0.525187 7.65616 0.389532 7.75618 0.289512C7.8562 0.189493 7.99185 0.133303 8.1333 0.133303H11.3333C11.4034 0.133119 11.4728 0.146782 11.5376 0.173507C11.6024 0.200232 11.6613 0.239493 11.7109 0.289036Z" fill="black" />
                                                                        </svg>
                                                                    </span>
    
                                                                </div>
                                                            : <div style={{width:"50px",marginLeft:"20px"}}></div>
                                                        }
    
                                                        {/* {
                                                            date.locationType === "2" ?
                                                            <p style={{width:"40px",marginLeft:"30px"}} className="mr_10 pointer" onClick={(e) => this.ClickAddScreenerPopup(e,item,date)}>
                                                                <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M22 13H18V6H22V13ZM23 4H17C16.7348 4 16.4804 4.10536 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5V15C16 15.2652 16.1054 15.5196 16.2929 15.7071C16.4804 15.8946 16.7348 16 17 16H23C23.2652 16 23.5196 15.8946 23.7071 15.7071C23.8946 15.5196 24 15.2652 24 15V5C24 4.73478 23.8946 4.48043 23.7071 4.29289C23.5196 4.10536 23.2652 4 23 4ZM4 2H22V0H4C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V13H0V16H14V13H4V2Z" fill="black"/>
                                                                </svg>
                                                            </p>
                                                            :''
                                                        } */}
                                                            
                                                
                                                    </div>
                                                    )
                                                }) : item.dateTime && item.dateTime.length >= 1 ? 
                                        item.dateTime.map((date) => {
                                            return(
                                                <div className="d_flex d_flex_align_center mb_5">
                                                    {date.date !== undefined && <>
                                                        <p className="aa" style={{width:"310px"}}>{moment(date.date).tz("US/Mountain").format('MMM DD - h:mm A')} - {moment(date.endDate).tz("US/Mountain").format('MMM DD - h:mm A')} { date.locationType === undefined || date.locationType === "2" ? '- Online' : date.locations.length > 0 ? ' - ' + this.getLocationslist(date.locations) : ''}</p>
                                                    {date.screeningType === "1" && date.locationType === "2" ?
                                                            <div className="d_flex d_flex_align_center" style={{width:"50px",marginLeft:"20px"}}>
                                                                <span className="mr_10 pointer" onClick={(e) => this.ScreenerPopup(e,date,item)}>
                                                                    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9.33333 5.33333H3.33333V3.33333C3.33333 2.23067 4.23067 1.33333 5.33333 1.33333C6.436 1.33333 7.33333 2.23067 7.33333 3.33333H8.66667C8.66667 1.49533 7.17133 0 5.33333 0C3.49533 0 2 1.49533 2 3.33333V5.33333H1.33333C0.979711 5.33333 0.640573 5.47381 0.390524 5.72386C0.140476 5.97391 0 6.31305 0 6.66667V12C0 12.3536 0.140476 12.6928 0.390524 12.9428C0.640573 13.1929 0.979711 13.3333 1.33333 13.3333H9.33333C9.68695 13.3333 10.0261 13.1929 10.2761 12.9428C10.5262 12.6928 10.6667 12.3536 10.6667 12V6.66667C10.6667 6.31305 10.5262 5.97391 10.2761 5.72386C10.0261 5.47381 9.68695 5.33333 9.33333 5.33333ZM4.04067 8.99933C4.12261 8.68562 4.31596 8.41247 4.58459 8.23089C4.85321 8.04932 5.17876 7.97174 5.5004 8.01265C5.82205 8.05356 6.11781 8.21016 6.33243 8.4532C6.54705 8.69624 6.66586 9.0091 6.66667 9.33333C6.66628 9.56649 6.60446 9.79544 6.48742 9.9971C6.37038 10.1988 6.20226 10.366 6 10.482V12H4.66667V10.482C4.41441 10.3375 4.21656 10.1141 4.10348 9.8463C3.9904 9.57846 3.96833 9.28092 4.04067 8.99933Z" fill="black" />
                                                                    </svg>
                                                                </span>
                                                                <span className="mr_10 pointer" onClick={(e) => this.scannerLogin(e, date, item)}>
                                                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.19997 0.133303C0.91707 0.133303 0.645759 0.245683 0.44572 0.445722C0.245681 0.645761 0.133301 0.917072 0.133301 1.19997V10.8C0.133301 11.0829 0.245681 11.3542 0.44572 11.5542C0.645759 11.7543 0.91707 11.8666 1.19997 11.8666H10.8C11.0829 11.8666 11.3542 11.7543 11.5542 11.5542C11.7543 11.3542 11.8666 11.0829 11.8666 10.8V7.06664C11.8666 6.92519 11.8104 6.78953 11.7104 6.68951C11.6104 6.58949 11.4748 6.5333 11.3333 6.5333C11.1919 6.5333 11.0562 6.58949 10.9562 6.68951C10.8562 6.78953 10.8 6.92519 10.8 7.06664V10.8H1.19997V1.19997H4.9333C5.07475 1.19997 5.21041 1.14378 5.31042 1.04376C5.41044 0.94374 5.46663 0.808085 5.46663 0.666636C5.46663 0.525187 5.41044 0.389532 5.31042 0.289512C5.21041 0.189493 5.07475 0.133303 4.9333 0.133303H1.19997ZM11.7109 0.289036C11.8101 0.388464 11.866 0.523 11.8666 0.663436V3.86664C11.8666 4.00809 11.8104 4.14374 11.7104 4.24376C11.6104 4.34378 11.4748 4.39997 11.3333 4.39997C11.1919 4.39997 11.0562 4.34378 10.9562 4.24376C10.8562 4.14374 10.8 4.00809 10.8 3.86664V1.9541L5.3109 7.44424C5.26131 7.49382 5.20245 7.53316 5.13766 7.55999C5.07287 7.58683 5.00343 7.60064 4.9333 7.60064C4.86317 7.60064 4.79373 7.58683 4.72895 7.55999C4.66416 7.53316 4.60529 7.49382 4.5557 7.44424C4.50611 7.39465 4.46678 7.33578 4.43994 7.27099C4.41311 7.2062 4.39929 7.13676 4.39929 7.06664C4.39929 6.99651 4.41311 6.92707 4.43994 6.86228C4.46678 6.79749 4.50611 6.73862 4.5557 6.68904L10.0458 1.19997H8.1333C7.99185 1.19997 7.8562 1.14378 7.75618 1.04376C7.65616 0.94374 7.59997 0.808085 7.59997 0.666636C7.59997 0.525187 7.65616 0.389532 7.75618 0.289512C7.8562 0.189493 7.99185 0.133303 8.1333 0.133303H11.3333C11.4034 0.133119 11.4728 0.146782 11.5376 0.173507C11.6024 0.200232 11.6613 0.239493 11.7109 0.289036Z" fill="black" />
                                                                    </svg>
                                                                </span>

                                                            </div>
                                                        : <div style={{width:"50px",marginLeft:"20px"}}></div>
                                                    }

                                                    {/* {
                                                        date.locationType === "2" ?
                                                        <p style={{width:"40px",marginLeft:"30px"}} className="mr_10 pointer" onClick={(e) => this.ClickAddScreenerPopup(e,item,date)}>
                                                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M22 13H18V6H22V13ZM23 4H17C16.7348 4 16.4804 4.10536 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5V15C16 15.2652 16.1054 15.5196 16.2929 15.7071C16.4804 15.8946 16.7348 16 17 16H23C23.2652 16 23.5196 15.8946 23.7071 15.7071C23.8946 15.5196 24 15.2652 24 15V5C24 4.73478 23.8946 4.48043 23.7071 4.29289C23.5196 4.10536 23.2652 4 23 4ZM4 2H22V0H4C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V13H0V16H14V13H4V2Z" fill="black"/>
                                                            </svg>
                                                        </p>
                                                        :''
                                                    } */}
                                                    </>}
                                                    

                                                        
                                            
                                                </div>
                                            )
                                            
                                        })
                                    // :
                                    // item.shortProgramme && item.shortProgramme.date ?
                                    // <p className="bbb">{moment(shortProgramme).format('MMM DD')} - {moment(shortProgramme).format("h:mm A")}</p>
                                    : '-'
                                    }
                                    </div>
                                </td>
                                
                                {/* <td>
                                { item.dateTime && item.dateTime.length >= 1 && 
                                        item.dateTime.map((date) => {
                                                return(
                                                    <>
                                                    {date.locationType === "2" ?
                                                        <p className="mr_10 w_100 pointer" onClick={(e) => this.ClickAddScreenerPopup(e,item,date)}>
                                                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M22 13H18V6H22V13ZM23 4H17C16.7348 4 16.4804 4.10536 16.2929 4.29289C16.1054 4.48043 16 4.73478 16 5V15C16 15.2652 16.1054 15.5196 16.2929 15.7071C16.4804 15.8946 16.7348 16 17 16H23C23.2652 16 23.5196 15.8946 23.7071 15.7071C23.8946 15.5196 24 15.2652 24 15V5C24 4.73478 23.8946 4.48043 23.7071 4.29289C23.5196 4.10536 23.2652 4 23 4ZM4 2H22V0H4C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V13H0V16H14V13H4V2Z" fill="black"/>
                                                            </svg>
                                                        </p> : '' }
                                                    </>
                                                )
                                                })}
                                </td> */}
                                <td style={{width:"90px"}}>
                                    <div>
                                        <p>{item.status === 1 ? 'Live' : item.status === 2 ? 'Disabled' : ''}</p>
                                    </div>
                                </td>
                                <td style={{width:"90px"}}>
                                    <div>
                                        <p>{item && item.awardCategory && item.awardCategory.name ? item && item.awardCategory && item.awardCategory.name : '-'}</p>
                                    </div>
                                </td>
                                {/* <td style={{width:"90px"}}>
                                    <div>
                                        <p>{item && item.votes}</p>
                                    </div>
                                </td>
                                <td style={{width:"90px"}}>
                                    <div>
                                        <p>{item && item.rating}</p>
                                    </div>
                                </td> */}
                            </tr>
                            )})}
                    </tbody>
                </table>
                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}
            </div>

             {/* For CSV upload successfully */}
             <div className={`user_popup ${this.state.successmodal ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>You have successfully uploaded {this.state.totalAddedRecord} users</p>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

               {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

            {/* Screen Modal */}
            {
                this.state.screenmodal ?
                    <div className="screener_popup">
                        <div className="screener_popup_innerpopup" >
                            <div className="screener_popup_header text_center">
                                <h3 className="mb_10"> Screener Credentials</h3>
                                <p>{ScreenerPopupFilmTitle} </p>
                                <p>{moment(ScreenerPopupData.date).tz("US/Mountain").format('MMM DD - h:mm A') + ' MT'} </p>
                            </div>
                            <div className="screener_popup_content">
                                <form>
                                    <h3 className="mb_5">PIN</h3>
                                    <h2 className="mb_15">{ScreenerPopupData.screenerCredential.pin}</h2>
                                    <div className="field_row">
                                        <div className="field_row_inner">
                                            <label>Password</label>
                                            <div className="field_input relative">
                                                <input
                                                    type={this.state.showPass ? "text" : "password"}
                                                    name="password"
                                                    id="password"
                                                    value={this.state.password}
                                                    onChange={this.onInputChange}
                                                />
                                                <span className="eye_icon" onClick={this.Showpassword}> {this.state.showPass ? <ShowPasswordIcon /> : <ViewIcon />} </span>
                                            </div>
                                            <span className='error srv-validation-message'>{this.state.passwordErr}</span>
                                        </div>

                                    </div>
                                    <div className="field_row pt_25">
                                        <button type='button' onClick={() => this.setState({ screenmodal: false,passwordErr:'',password:'' })}>CANCEL</button>
                                        <button className="active" type='button' onClick={() => this.scannerSave(ScreenerPopupData, ScreenerPopupFilmData)}>SAVE</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    :
                    ""
            }

            {
                this.state.addScreenerPopup ?
                    <div className="screener_popup " style={{ maxWidth: "656px" }}>
                        <div className="screener_popup_innerpopup p_0 screener_popup_filmlink_popup" >
                            <div className="popup_header dark_gray text_center relative">
                                <h3 className=""> Create Film Access Link</h3>
                                <span className="close_popup pointer" onClick={this.CloseModal}>
                                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.545654L5.94897 4.9225L1.70697 0.545654L0.292969 2.0046L4.53497 6.38145L0.292969 10.7583L1.70697 12.2173L5.94897 7.8404L10.192 12.2173L11.606 10.7583L7.36397 6.38145L11.606 2.0046L10.192 0.545654Z" fill="white" />
                                    </svg>
                                </span>
                            </div>
                            <div className="screener_popup_content text_center">
                                <form onSubmit={(e) => this.setEmailGo(e)}>
                                    <div className="field_row horizontal_field d_flex d_flex_align_baseline">
                                        <TextField
                                            placeholder=""
                                            label="Email"
                                            name='email'
                                            value={this.state.email}
                                            onChange={(e) => this.onInputChange(e)}
                                            fpgerror={this.state.isExist === false ? "This user doesn’t exist in our database. Please try again" : ''}
                                            maxLength={255} />
                                        <button className="ml_25 active" style={{ padding: "12px", minWidth: "76px" }} type='button' onClick={(e) => this.setEmailGo(e)}>Go</button>
                                    </div>
                                    {this.state.isExist && this.state.userEmail ?.email &&
                                        <>
                                        <div className="mb_25">
                                            <p className="mb_5">The following user is found in our database</p>
                                            <p className="mb_5"><a href="javascript:;">{this.state.userEmail ?.email} </a>  -  {this.state.userEmail ?.fname} {this.state.userEmail ?.lname} </p>
                                        </div>

                                        <div className="field_row mb_25">
                                            <button className="active uppercase" type='button' onClick={(e) => this.setLink(e)}>Get Link</button>
                                        </div>
                                        </>
                                }
                                    <div className="field_row mb_25">
                                        <p className="mb_25"><a href="javascript:;" className="d_block">{this.state.linkCopy}</a></p>
                                        {this.state.linkCopy &&
                                            <button className="active uppercase" type='button' onClick={(e) => this.copyLink(e, this.state.linkCopy)}>COPY Link</button>
                                        }
                                    </div>

                                    {/* <div className="field_row mb_0">
                                <button className="active uppercase">COMMON Link</button>
                            </div> */}
                                </form>
                            </div>
                        </div>
                    </div>
                    :
                    ""
                }

                <span className="head_btn pointer upload_pdf_btn"  style={{marginLeft:'17px',marginTop:'10px'}}><input type="file" accept='.pdf'  onChange={this.uploadPDF} className="upload_pdf"/>Upload PDF <img src={upload} style={{width:'20px',marginLeft:'10px'}} /> {this.state.fileUploading &&
                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                }</span> 
                <span style={{marginLeft:'17px'}}>Last Uploaded {moment(this.state.uploadDate).tz("US/Mountain").format('DD/MM/YYYY')} {moment(this.state.uploadDate).tz("US/Mountain").format('h:mm A')} by {this.state.uploadFname} {this.state.uploadLname}</span>
                                 
            {/* ReactPaginate  */}
            {this.state.exploreListFlim && this.state.exploreListFlim.length && this.state.exploreListFlim ? (
                <div className="custom-pagination">
                    <ReactPaginate
                        previousLabel={""}
                        nextLabel={""}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={this.state.pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={this.state.FilmCurrentPage}
                    />

                </div>
            ) : (
                    ""
                )}
            </>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FilmListTable)